import { useGetSalesReturnsQuery } from '@/features/slice/sales-return/sales-return.api-slice';

export const useSalesReturnList = () => {
    const { data, isLoading, isError, error, isFetching } =
        useGetSalesReturnsQuery({});
    return {
        data,
        isLoading,
        isError,
        error,
        isFetching,
    };
};
